import { TranslationKey, TranslationKeys } from './translations-keys';

export const enUSTranslations: Record<TranslationKey, string> = {
    [TranslationKeys.PUPIL]: 'student',
    [TranslationKeys.PUPILS]: 'students',
};
